export const windowHasAndroid = function() {
	let has = (window.Android !== undefined);
	return has;
};

export const getAndroidObject = function() {
	let has = windowHasAndroid();
	if(!has) {
	    throw 'window no tiene Android';
	}
	return window.Android;
};